function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-72%",
  y: "-52.9%",
  width: "244%",
  height: "205.9%",
  filterUnits: "objectBoundingBox",
  id: "no-stock_svg__a"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.25 0",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 0C5.593 0 0 5.712 0 12.75c0 4.723 1.562 6.198 9.848 19.75a3.095 3.095 0 005.304 0C23.442 18.942 25 17.473 25 12.75 25 5.704 19.4 0 12.5 0z",
  id: "no-stock_svg__b"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  transform: "translate(12.5 12)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#no-stock_svg__a)",
  xlinkHref: "#no-stock_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#no-stock_svg__b"
})), /*#__PURE__*/React.createElement("path", {
  d: "M19 25a6 6 0 1112 0 6 6 0 01-12 0z",
  fill: "#C2002F"
}));

function SvgNoStock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 58
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTgiIHZpZXdCb3g9IjAgMCA1MCA1OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZGVmcz4KICAgICAgICA8ZmlsdGVyIHg9Ii03MiUiIHk9Ii01Mi45JSIgd2lkdGg9IjI0NCUiIGhlaWdodD0iMjA1LjklIiBmaWx0ZXJVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giIGlkPSJjc3J5czljMm9hIj4KICAgICAgICAgICAgPGZlT2Zmc2V0IGluPSJTb3VyY2VBbHBoYSIgcmVzdWx0PSJzaGFkb3dPZmZzZXRPdXRlcjEiLz4KICAgICAgICAgICAgPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iNiIgaW49InNoYWRvd09mZnNldE91dGVyMSIgcmVzdWx0PSJzaGFkb3dCbHVyT3V0ZXIxIi8+CiAgICAgICAgICAgIDxmZUNvbG9yTWF0cml4IHZhbHVlcz0iMCAwIDAgMCAwLjIgMCAwIDAgMCAwLjIgMCAwIDAgMCAwLjIgMCAwIDAgMC4yNSAwIiBpbj0ic2hhZG93Qmx1ck91dGVyMSIvPgogICAgICAgIDwvZmlsdGVyPgogICAgICAgIDxwYXRoIGQ9Ik0xMi41IDBDNS41OTMgMCAwIDUuNzEyIDAgMTIuNzVjMCA0LjcyMyAxLjU2MiA2LjE5OCA5Ljg0OCAxOS43NWEzLjA5NSAzLjA5NSAwIDAgMCA1LjMwNCAwQzIzLjQ0MiAxOC45NDIgMjUgMTcuNDczIDI1IDEyLjc1IDI1IDUuNzA0IDE5LjQgMCAxMi41IDB6IiBpZD0ibml4Mmt4dnM5YiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjUgMTIpIj4KICAgICAgICAgICAgPHVzZSBmaWxsPSIjMDAwIiBmaWx0ZXI9InVybCgjY3NyeXM5YzJvYSkiIHhsaW5rOmhyZWY9IiNuaXgya3h2czliIi8+CiAgICAgICAgICAgIDx1c2UgZmlsbD0iI0ZGRiIgeGxpbms6aHJlZj0iI25peDJreHZzOWIiLz4KICAgICAgICA8L2c+CiAgICAgICAgPHBhdGggZD0iTTE5IDI1YTYgNiAwIDEgMSAxMiAwIDYgNiAwIDAgMS0xMiAweiIgZmlsbD0iI0MyMDAyRiIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgNoStock as ReactComponent };